import {FormDescription, FormMessage} from '@/components/ui/form';
import {Circle, CircleCheck} from 'lucide-react';

export interface CreatePasswordRequirementsProps {
  isPasswordDirty: boolean;
  password: string;
}

export default function CreatePasswordRequirements({
  isPasswordDirty,
  password,
}: CreatePasswordRequirementsProps) {
  const requirements = {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /\d/.test(password),
  };

  if (!isPasswordDirty) {
    return <FormMessage />;
  }

  return (
    <FormDescription>
      Please enter a password that meets the following criteria:
      <ul>
        <Requirement complete={requirements.length}>
          Must be at least 8 characters long.
        </Requirement>
        <Requirement complete={requirements.uppercase}>
          Must contain at least one uppercase letter (A-Z).
        </Requirement>
        <Requirement complete={requirements.lowercase}>
          Must contain at least one lowercase letter (a-z).
        </Requirement>
        <Requirement complete={requirements.number}>
          Must contain at least one number (0-9).
        </Requirement>
      </ul>
    </FormDescription>
  );
}

function Requirement({children, complete}: {children: React.ReactNode; complete: boolean}) {
  return (
    <li className="leading-1 flex items-center gap-2">
      {complete ? <CircleCheck color="green" size="16" /> : <Circle size="16" />}{' '}
      <span className="flex-1">{children}</span>
    </li>
  );
}
